import Home from "../home";
import { Hochimin } from "../pages/Hochimin";
import { Osaka } from "../pages/Osaka";
import { Losangeles } from "../pages/Losangeles";
import { NewYork } from "../pages/NewYork";
import { Seoul } from "../pages/Seoul";

export const routerInfo = [
    {
      path: "/",
      element: <Home/>,
      errorElement: <div>error</div>,
      children: [
        {
            path: "/*",
            element: <div className="dim">Not Found</div>,
        },
        {
            path: "seoul",
            element: <Seoul />,
        },
        {
            path: "hochiminhcity",
            element: <Hochimin />,  
        },
        {
            path: "newyork",
            element: <NewYork />,
        },
        {
            path: "osaka",
            element: <Osaka />,
        },
        {
            path: "losangeles",
            element: <Losangeles />,
        },
      ]
    },
]